var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('show-information',{attrs:{"show":_vm.data.show},on:{"change-step-next":function () { return _vm.$emit('proceed', _vm.data); },"change-step-prev":function () { return _vm.$emit('back', _vm.data); }}})}
var staticRenderFns = []

export { render, staticRenderFns }